module.exports = __webpack_public_path__ + "assets/img/kv-56cb9baf.jpg";